<template>
  <Dialog
    :title="$t('fdd678fd78')"
    :visible.sync="showDialog"
    :screenfull="isMobile"
  >
    <div slot="content" v-if="!isMobile">
      <div :class="$style.tips">{{ $t("471041043d") }}</div>
      <div :class="$style.number">3312538989</div>
      <button class="kButton" :class="$style.copy" @click="copyToClip">
        {{ $t("89a75c2d8d") }}
      </button>
    </div>
    <div slot="content" :class="$style.mobilecontent" v-else>
      <div :class="$style.name">{{ $t("1894fcb0c1") }}</div>
      <div :class="$style.savetips">{{ $t("081814f2bd") }}</div>
      <img :class="$style.code" src="./assets/code.png" />
    </div>
  </Dialog>
</template>
<script>
import i18n from '@/i18n'
import Dialog from './Dialog'
export default {
  name: 'ContactDialog',
  components: {
    Dialog
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      showDialog: false
    }
  },
  methods: {
    show() {
      this.showDialog = true
    },
    close() {
      this.showDialog = false
    },
    copyToClip() {
      var aux = document.createElement('input')
      aux.setAttribute('value', '3312538989')
      document.body.appendChild(aux)
      aux.select()
      document.execCommand('copy')
      document.body.removeChild(aux)
      this.$message.success(i18n.t('26b115245d'))
    }
  }
}
</script>
<style lang="scss" module>
.tips {
  line-height: 40px;
  color: #2f2f2f;
}
.number {
  line-height: 40px;
  color: #4e90ff;
}
.copy {
  width: 140px;
  height: 30px;
  font-size: 14px;
  margin-top: 20px;
}
.name {
  line-height: 40px;
  font-size: 18px;
  color: #2f2f2f;
  font-weight: 400;
}
.savetips {
  line-height: 40px;
  color: #6d757e;
  font-size: 14px;
}
.code {
  margin-top: 20px;
  width: 180px;
  height: 180px;
}
.mobilecontent {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
